// ApiError is a custom error class for handling API errors in a consistent, type-safe way across the frontend.
// It wraps the ErrorResponse type from the shared schemas package, allowing all API services to throw and handle errors
// with detailed information (code, message, details, timestamp) in a unified format. This enables shared error display
// components and predictable error handling throughout the app.

import type { ErrorResponse } from 'schemas';

export class ApiError extends Error {
  code: string;
  details?: ErrorResponse['details'];
  timestamp?: string;

  constructor(errorResponse: ErrorResponse) {
    super(errorResponse.message || errorResponse.error);
    this.name = 'ApiError';
    this.code = errorResponse.code;
    this.details = errorResponse.details;
    this.timestamp = errorResponse.timestamp;
  }
}
